<template>
  <div class="diagnose">
    <portal to="cardActions">
      <v-select
        :items="userAnatomicalRegions"
        item-text="label"
        item-value="id"
        v-model="selectedRegion"
        :loading="fetchingLogs"
        :hint="selectedRegion ? '' : 'Por favor escolha uma região anatómica'"
        persistent-hint
      >
      </v-select>
    </portal>
    <table
      v-if="selectedRegion"
      :style="cssVars"
      :class="style.borders ? 'bordered' : ''"
      class="combined-report styled-table selectable"
    >
      <thead>
        <tr>
          <th style="min-width: 150px" class="header-title"></th>
          <th class="header-title" v-for="row in tableItems" :key="row.id">
            <span class="" v-text="row.label"></span>
          </th>
        </tr>
      </thead>
      <template v-for="(item, key) in benignTableValues('benign')">
        <tr :key="key" v-if="key === 0">
          <td class="categ-title divider" colspan="6">Patologia Benigna</td>
        </tr>
        <tr
          :class="key % 2 == 0 ? 'even' : 'odd'"
          :key="key + index + row.title"
          v-for="(row, index) in item.rowData"
        >
          <td class="categ-title" v-if="row.hideCell" :rowspan="row.rowspan">
            {{ row.title }}
          </td>
          <td
            class="subcateg-title"
            v-text="row.items ? row.items.join(' + ') : ''"
          ></td>
          <td v-for="value in row.values" :key="value.item + key">
            {{ value.count }}
          </td>
        </tr>
      </template>
      <template v-for="(item, key) in benignTableValues('malignant')">
        <tr :key="'M' + key" v-if="key === 0">
          <td class="categ-title divider" colspan="6">Patologia Maligna</td>
        </tr>
        <tr
          :class="key % 2 == 0 ? 'even' : 'odd'"
          :key="'M' + key + index + row.title"
          v-for="(row, index) in item.rowData"
        >
          <td class="categ-title" v-if="row.hideCell" :rowspan="row.rowspan">
            {{ row.title }}
          </td>
          <td
            class="subcateg-title"
            v-text="row.items ? row.items.join(' + ') : ''"
          ></td>
          <td v-for="value in row.values" :key="value.item + key">
            {{ value.count }}
          </td>
        </tr>
      </template>
      <template v-for="(item, key) in benignTableValues('other')">
        <tr :key="'M' + key" v-if="key === 0">
          <td class="categ-title divider" colspan="6">Não definido / outras</td>
        </tr>
        <tr
          :class="key % 2 == 0 ? 'even' : 'odd'"
          :key="'M' + key + index + row.title"
          v-for="(row, index) in item.rowData"
        >
          <td class="categ-title" v-if="row.hideCell" :rowspan="row.rowspan">
            {{ row.title }}
          </td>
          <td
            class="subcateg-title"
            v-text="row.items ? row.items.join(' + ') : ''"
          ></td>
          <td v-for="value in row.values" :key="value.item + key">
            {{ value.count }}
          </td>
        </tr>
      </template>
      <tr>
        <td class="total">Total</td>
        <td class="total" v-for="item in tableTotals" :key="item.id">
          {{ item.total }}
        </td>
      </tr>
    </table>
  </div>
</template>

<script>
import {
  GeneralSurgery,
  SurgeryDiagnosis,
  SurgeryProcedure
} from '@/models/GeneralSurgery'
import { mapGetters } from 'vuex'
import helpers from '../../mixins/statsHelperFunc'
export default {
  props: {
    logs: { default: [] },
    logbookType: String
  },
  mixins: [helpers],
  data() {
    return {
      style: {
        borders: true,
        borderColor: '#cccccc',
        colors: ['#ffffff']
      },
      selectedRegion: '',
      fetchingLogs: false,
      SurgeryDiagnosisOrm: [],
      SurgeryProcedureOrm: [],
      tableItems: [
        { id: 'surgery-procedure-ids', label: '' },
        { id: 'surgeon', label: 'Cirurgião', component: 'autonomy', total: 0 },
        { id: 'helper', label: 'Ajudante', component: 'autonomy', total: 0 },
        { id: 'observer', label: 'Observador', component: 'autonomy', total: 0 }
      ]
    }
  },
  computed: {
    ...mapGetters(['user']),
    components() {
      return this.allStatsComponents(this.logbookType)
    },
    anatomicalRegions() {
      const tree = GeneralSurgery.query().first().organTree
      return tree.flatMap(n => (n.children ? [...n.children] : [n]))
    },
    userAnatomicalRegions() {
      const availableRegions = this.anatomicalRegions.filter(item =>
        this.logs.find(log => log['anatomic-region'] === item.id)
      )
      return availableRegions
    },
    filteredLogsByRegion() {
      this.fetchingLogs = true
      const filteredLogs = this.logs.filter(log => {
        return (
          log['anatomic-region'] === this.selectedRegion &&
          log['surgery-procedure'] &&
          log['surgery-procedure'].length > 0
        )
      })
      this.fetchingLogs = false
      return filteredLogs
    },
    tableTotals() {
      this.tableItems.forEach(item => {
        if (item.id !== 'surgery-procedure-ids') {
          item.total = 0
          this.filteredLogsByRegion.forEach(log => {
            log['autonomy'] = this.getAutonomy(log)
            if (log['autonomy']) {
              log['autonomy'].includes(item.id) ? item.total++ : ''
            }
          })
        }
      })
      return this.tableItems
    },
    cssVars() {
      return {
        '--bg-color': this.style.colors[0],
        '--bg-light-color': this.style.colors[0] + 20,
        '--bg-odd-color': this.style.colors[0] + 40,
        '--categ-color': this.style.colors[0] + 99,
        '--subcateg-color': this.style.colors[0] + 60,
        '--border-collapse': this.style.borders ? 'collapse' : 'inherit',
        '--border-color': this.style.borderColor,
        '--accent-border-color': this.style.borderColor + 50
      }
    }
  },
  methods: {
    benignTableValues(benign) {
      if (this.filteredLogsByRegion && this.filteredLogsByRegion.length) {
        let beningLogs = []
        if (benign === 'other') {
          beningLogs = this.filteredLogsByRegion.filter(log => {
            return (
              log['classification-benign-suspicious-malignant'] !== 'benign' &&
              log['classification-benign-suspicious-malignant'] !== 'malignant'
            )
          })
        } else {
          beningLogs = this.filteredLogsByRegion.filter(
            log => log['classification-benign-suspicious-malignant'] === benign
          )
        }
        const beningLogsSorted = beningLogs.sort(function (a, b) {
          return a['surgery-diagnosis'].localeCompare(b['surgery-diagnosis'])
        })
        const rows = []
        beningLogsSorted.forEach(log => {
          if (log['surgery-procedure-ids']) {
            if (
              !rows.some(
                e =>
                  e.rowTitle === log['surgery-diagnosis'] &&
                  e.rowProcedure.join('') ===
                    log['surgery-procedure-ids'].join('')
              )
            ) {
              const rowspan = rows.filter(
                e => e.rowTitle === log['surgery-diagnosis']
              ).length
              let row = {
                rowTitle:
                  log['surgery-diagnosis'] === 'other'
                    ? 'outro'
                    : log['surgery-diagnosis'],
                rowProcedure: log['surgery-procedure-ids'],
                rowData: [
                  {
                    hideCell: rowspan < 1 ? true : false,
                    title:
                      log['surgery-diagnosis'] === 'other'
                        ? log['surgery-diagnosis-other']
                        : log['surgery-diagnosis'],
                    items: log['surgery-procedure-ids'],
                    values: this.getValues(
                      log['surgery-diagnosis'],
                      log['surgery-procedure-ids']
                    )
                  }
                ]
              }
              const index = row.rowData[0].items.indexOf('other')
              row.rowData[0].items[index] = log['surgery-procedure-other']
              rows.push(row)
            }
          }
        })
        // setting rowspans
        const counts = {}
        rows.forEach(row => {
          counts[row.rowTitle] = (counts[row.rowTitle] || 0) + 1
        })
        rows.map(row => {
          row.rowData[0].rowspan = counts[row.rowData[0].title]
          this.SurgeryDiagnosisOrm.find(item => item.id === row.rowTitle)
            ? (row.rowData[0].title = this.SurgeryDiagnosisOrm.find(
                item => item.id === row.rowTitle
              ).label)
            : ''
          row.rowData[0].items = this.getDiagnosisLabel(row.rowData[0].items)
        })
        this.fetchingLogs = false
        return rows
      }
    },
    getSurgeryLabels(item) {
      const result = SurgeryDiagnosis.query()
        .where(l => l.id === item)
        .get()
      return result[0].label
    },
    getDiagnosisLabel(items) {
      if (items && items.length) {
        const allLabels = items.map(item => {
          const result = this.SurgeryProcedureOrm.find(x => x.id === item)
          return result ? result.label : item
        })
        return allLabels
      }
    },
    getAutonomy(log) {
      if (
        log['surgeon'] === this.user.id ||
        log['surgeon'] === this.user.license
      ) {
        return 'surgeon'
      }
      if (
        log['helper-1'] === this.user.id ||
        log['helper-1'] === this.user.license
      ) {
        return 'helper'
      }
      if (
        log['helper-2'] === this.user.id ||
        log['helper-2'] === this.user.license
      ) {
        return 'helper'
      }
      if (
        log['helper-3'] === this.user.id ||
        log['helper-3'] === this.user.license
      ) {
        return 'helper'
      }
      if (
        log['observer'] === this.user.id ||
        log['observer'] === this.user.license
      ) {
        return 'observer'
      }
    },
    getValues(diagnose, procedures) {
      const values = []
      let parsedLogs = JSON.parse(JSON.stringify(this.logs))
      let groupCount = 0
      this.tableItems.forEach((row, index) => {
        let count = 0
        let type = 0
        if (row.id === 'surgery-procedure-ids') {
          type = procedures
        } else {
          parsedLogs.forEach(log => {
            // adding autonomy
            log['autonomy'] = this.getAutonomy(log)
            if (
              log[row.component] &&
              log['surgery-procedure-ids'] &&
              log['autonomy'].includes(row.id) &&
              log['surgery-diagnosis'] === diagnose &&
              log['surgery-procedure-ids'].join('') === procedures.join('')
            ) {
              count++
            }
          })
          values.push({
            item: index,
            type: row.id,
            count: count,
            component: row.component ? row.component : row.parentComponent,
            group: groupCount
          })
        }
      })
      return values
    },
    getLabels(label) {
      switch (label) {
        case 'elective':
          return 'Electivo'
        case 'emergency':
          return 'Urgência'
        case 'ambulatory':
          return 'Ambulatório'
      }
    }
  },
  created() {
    this.SurgeryDiagnosisOrm = SurgeryDiagnosis.query().get()
    this.SurgeryProcedureOrm = SurgeryProcedure.query().get()
  },
  mounted() {
    this.$root.$emit('isTable', true)
    this.$root.$on('selectedStyle', style => {
      this.style = style
    })
  }
}
</script>

<style>
.diagnose .v-messages__message {
  color: red;
}

.styled-table {
  font-size: 0.9em;
  font-family: sans-serif;
  width: 100%;
}
.styled-table.border td,
.styled-table.bordered thead {
  border-bottom: 1px solid var(--border-color);
}
.styled-table.bordered tr td,
.styled-table.border thead th {
  border-right: 1px solid var(--accent-border-color);
}
.styled-table.bordered tr td:last-child,
.styled-table.bordered thead th:last-child {
  border-right: none;
}
.categ-title {
  background-color: var(--categ-color) !important;
  width: 20px;
  font-weight: bold;
}
.divider {
  text-align: left !important;
  padding: 5px 15px !important;
}
.subcateg-title {
  background-color: var(--subcateg-color) !important;
}
.rotate-text {
  writing-mode: vertical-lr;
  -ms-writing-mode: tb-rl;
  transform: rotate(180deg);
}
.combined-report thead th.header-title {
  background-color: var(--categ-color) !important;
}
.combined-report thead th.total {
  background-color: var(--bg-color) !important;
}
.styled-table th,
.styled-table td {
  padding: 12px 15px;
  text-align: center;
  vertical-align: middle;
}

.odd {
  background-color: var(--bg-odd-color);
}
.even {
  background-color: var(--bg-light-color);
}

tr.total td {
  background-color: var(--bg-odd-color);
}
tr.total td.odd {
  background-color: var(--subcateg-color);
}
.styled-table td.total {
  background-color: var(--subcateg-color);
  font-weight: bold;
  min-width: 70px;
}
.total-cell {
  background-color: var(--categ-color) !important;
  font-weight: bold;
}
.styled-table tr:last-of-type {
  border-bottom: 1px solid var(--border-color);
}
</style>
